import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

export interface DSDiffActionsProps {
  /** Callback when Accept button is clicked */
  onAccept: () => void;
  /** Callback when Reject button is clicked */
  onReject: () => void;
  /** Whether buttons should be disabled (e.g., during loading) */
  disabled?: boolean;
  /** Test ID for automated testing */
  dataTestId: string;
}

/**
 * Accept/Reject action buttons for diff view.
 * Displays a green Accept button and a red Reject button in a horizontal layout.
 */
export const DSDiffActions = ({
  onAccept,
  onReject,
  disabled = false,
  dataTestId,
}: DSDiffActionsProps) => {
  return (
    <div
      className="flex items-center overflow-hidden gap-sm"
      data-testid={dataTestId}
      data-intercom-target={dataTestId}
    >
      <button
        className={`
          px-sm py-xs text-sm font-semibold rounded-full
          transition-all shadow-md
          ${
            disabled
              ? "bg-disabled text-white cursor-not-allowed"
              : "bg-success text-white cursor-pointer"
          }
        `}
        onClick={onAccept}
        disabled={disabled}
        data-testid={`${dataTestId}-accept`}
        data-intercom-target={`${dataTestId}-accept`}
        aria-label="Accept changes"
      >
        Accept New <FontAwesomeIcon icon={faCheck} />
      </button>
      <button
        className={`
          px-sm py-xs text-sm font-semibold rounded-full
          transition-all shadow-md
          ${
            disabled
              ? "bg-disabled text-white cursor-not-allowed"
              : "bg-danger text-white cursor-pointer"
          }
        `}
        onClick={onReject}
        disabled={disabled}
        data-testid={`${dataTestId}-reject`}
        data-intercom-target={`${dataTestId}-reject`}
        aria-label="Reject changes"
      >
        Reject <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};
